import { Component, EventEmitter, Input, Output, OnInit, SecurityContext, ElementRef, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { formatTimespan } from 'rev-shared/date/DateFormatters';
import { parseTimespanToSecs } from 'rev-shared/date/DateParsers.Service';
import { IPulseTimelineEntry } from './IPulseTimelineEntry';
import { PulseTimelineEntryType } from './PulseTimelineEntryType';

import styles from './PulseTimelineEntry.module.less';
import { DomSanitizer } from '@angular/platform-browser';

function formatTime(timeSecs: number): string {
	return formatTimespan(timeSecs * 1000, { noDays: true, padFields: true });
}

@Component({
	selector: 'edit-pulse-subtitle',
	templateUrl: './EditPulseSubtitle.Component.html'
})
export class EditPulseSubtitleComponent implements OnInit {
	@Input() public entry: IPulseTimelineEntry;

	@Output() public cancel = new EventEmitter<void>();
	@Output() public save = new EventEmitter<IPulseTimelineEntry>();
	@Output() public delete = new EventEmitter<IPulseTimelineEntry>();

	@ViewChild('textInput') public textInput: ElementRef;
	@ViewChild(NgForm) public form: NgForm;

	public readonly styles: any = styles;
	public readonly timeRx = /^(\d+:)?\d{1,2}:\d{1,2}(\.\d+)?$/;

	public text: string;
	public textInvalid: boolean = false;
	public startTime: string;
	public endTime: string;

	constructor(
		private readonly domSanitizer: DomSanitizer
	) {}

	public ngOnInit(): void {
		this.text = this.entry.text;
		this.startTime = formatTime(this.entry.startSecs);
		this.endTime = formatTime(this.entry.endSecs);
	}

	public ngAfterViewInit(): void {
		this.textInput.nativeElement.innerHTML = this.domSanitizer.sanitize(SecurityContext.HTML, this.text);
		this.form.form.setValidators(() => this.textInvalid ? { 'textRequired': true } : undefined);
	}

	public updateText(el: HTMLElement): void {
		this.text = el.innerHTML;
		this.textInvalid = !el.innerText.trim();
		this.form.form.updateValueAndValidity();
	}

	public onSave(): void {
		const text = this.cleanupHtml(this.text);

		this.save.emit({
			text,
			filterValue: text,
			startSecs: parseTimespanToSecs(this.startTime),
			endSecs: parseTimespanToSecs(this.endTime),
			type: PulseTimelineEntryType.TRANSCRIPTION
		});
	}

	private cleanupHtml(inputHtml: string): string {
		const html = this.domSanitizer.sanitize(SecurityContext.HTML, inputHtml);

		const textarea = document.createElement('textarea');
		textarea.innerHTML = html;

		return textarea.value;
	}
}

